import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { subscribeToUserCollection } from './utils/userDataHelper';
import { useAuth } from './contexts/AuthContext';
import { normalizeRecipe } from './utils/recipeSchema';
import CreateRecipe from './labcomponents/CreateRecipe';
import Breadcrumbs from './Components/Breadcrumbs';
import Footer from './Components/Footer';
import SafetyNotice from './Components/SafetyNotice';
import './styles/pages.css';

// The calculator owns one calculation state. The wrapper only supplies private
// inventory and a recipe selected elsewhere, avoiding two competing engines.
export default function Lab() {
  const { user } = useAuth();
  const [ingredients, setIngredients] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState(null);

  useEffect(() => {
    if (!user) { setIngredients([]); return undefined; }
    return subscribeToUserCollection('ingredients', data => {
      setIngredients(data.map(item => ({ ...item, firebaseId: item.id })));
    });
  }, [user]);

  useEffect(() => {
    const stored = sessionStorage.getItem('editRecipe');
    if (!stored) return;
    try { setSelectedRecipe(normalizeRecipe(JSON.parse(stored))); }
    catch (error) { console.error('Unable to open selected recipe:', error); }
    finally { sessionStorage.removeItem('editRecipe'); }
  }, []);

  return (
    <div className="sl-page">
      <div className="pageheader borderleft">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Recipes', to: '/recipes' }, { label: 'New Recipe' }]} />
        <div className="pageheader-row">
          <div className="pageheading">New Recipe</div>
          <div className="pagedescription">Design your soap recipe with the lye calculator. Working from a premade base? Use the <Link to="/melt-and-pour">melt &amp; pour calculator</Link>.</div>
        </div>
      </div>
      <div className="borderleft lab-safety"><SafetyNotice /></div>
      <div className="borderleft"><CreateRecipe ingredients={ingredients} selectedRecipe={selectedRecipe} /></div>
      <Footer />
    </div>
  );
}
